// The 30 Lowcountry service-area cities. Unique copy + neighborhoods are
// filled in on the city template in Phase 3.

export const CITIES = [
  { slug: "charleston-sc", name: "Charleston", county: "Charleston County" },
  { slug: "north-charleston-sc", name: "North Charleston", county: "Charleston County" },
  { slug: "mount-pleasant-sc", name: "Mount Pleasant", county: "Charleston County" },
  { slug: "west-ashley-sc", name: "West Ashley", county: "Charleston County" },
  { slug: "daniel-island-sc", name: "Daniel Island", county: "Berkeley County" },
  { slug: "park-circle-sc", name: "Park Circle", county: "Charleston County" },
  { slug: "summerville-sc", name: "Summerville", county: "Dorchester County" },
  { slug: "goose-creek-sc", name: "Goose Creek", county: "Berkeley County" },
  { slug: "hanahan-sc", name: "Hanahan", county: "Berkeley County" },
  { slug: "ladson-sc", name: "Ladson", county: "Dorchester County" },
  { slug: "moncks-corner-sc", name: "Moncks Corner", county: "Berkeley County" },
  { slug: "bonneau-sc", name: "Bonneau", county: "Berkeley County" },
  { slug: "cane-bay-sc", name: "Cane Bay", county: "Berkeley County" },
  { slug: "nexton-sc", name: "Nexton", county: "Berkeley County" },
  { slug: "carnes-crossroads-sc", name: "Carnes Crossroads", county: "Berkeley County" },
  { slug: "lincolnville-sc", name: "Lincolnville", county: "Dorchester County" },
  { slug: "johns-island-sc", name: "Johns Island", county: "Charleston County" },
  { slug: "james-island-sc", name: "James Island", county: "Charleston County" },
  { slug: "folly-beach-sc", name: "Folly Beach", county: "Charleston County" },
  { slug: "isle-of-palms-sc", name: "Isle of Palms", county: "Charleston County" },
  { slug: "sullivans-island-sc", name: "Sullivan's Island", county: "Charleston County" },
  { slug: "kiawah-island-sc", name: "Kiawah Island", county: "Charleston County" },
  { slug: "seabrook-island-sc", name: "Seabrook Island", county: "Charleston County" },
  { slug: "wadmalaw-island-sc", name: "Wadmalaw Island", county: "Charleston County" },
  { slug: "edisto-island-sc", name: "Edisto Island", county: "Colleton County" },
  { slug: "awendaw-sc", name: "Awendaw", county: "Charleston County" },
  { slug: "mcclellanville-sc", name: "McClellanville", county: "Charleston County" },
  { slug: "ravenel-sc", name: "Ravenel", county: "Charleston County" },
  { slug: "hollywood-sc", name: "Hollywood", county: "Charleston County" },
  { slug: "meggett-sc", name: "Meggett", county: "Charleston County" },
];

export const getCity = (slug) => CITIES.find((c) => c.slug === slug);
export const cityPath = (c) => `/service-areas/${c.slug}`;
export const getNeighborsSameCity = (slug, n = 3) => {
  const i = CITIES.findIndex((c) => c.slug === slug);
  return [1, 2, 3, 4].slice(0, n).map((k) => CITIES[(i + k) % CITIES.length]);
};
